const LightOutlinedButton = ({ onClick, text }) => {
  return (
    <button
      className="bg-transparent py-s px-m bg-primary2-hover border-white no-border-hover"
      onClick={onClick}
    >
      <div className="button-text">{text}</div>
    </button>
  );
};

export default LightOutlinedButton;
